import { useEffect, useMemo, useState } from "react";
import { getSnapshotChipData } from "./snapshot-chip";

interface UseSnapshotStateParams {
  snapshotUrl: string | null;
  snapshotCapturedAt?: string | null;
  isOnline: boolean;
  cameraKey?: string;
}

export function useSnapshotState({ snapshotUrl, snapshotCapturedAt, isOnline, cameraKey }: UseSnapshotStateParams) {
  const [snapshotError, setSnapshotError] = useState(false);

  useEffect(() => {
    setSnapshotError(false);
  }, [cameraKey, snapshotUrl, snapshotCapturedAt]);

  const chipState = useMemo(() => getSnapshotChipData(snapshotCapturedAt, isOnline), [snapshotCapturedAt, isOnline]);

  return {
    snapshotError,
    setSnapshotError,
    chipState,
  };
}
